import fetch from "../fetch";

export default ({ fundId, feeStructureId }) =>
  fetch({
    path: `/hy/funds/${fundId}/performance-fees/${feeStructureId}`,
    method: "DELETE",
  });
